import { render, staticRenderFns } from "./register.vue?vue&type=template&id=388fc8af&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=388fc8af&prod&lang=scss&scoped=true"
import style1 from "./register.vue?vue&type=style&index=1&id=388fc8af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388fc8af",
  null
  
)

export default component.exports